<template>
  <div class="global">
    <div class="choosing">
      <search id="showsList_search" class="search" color="#555" :shows-list="showsData" :seasons-indexes="seasonsIndex" :seasons-list="seasonsData"
              @searchingStart="selectLevel(-1)"></search>
      <div id="showsList_levelSelect" class="filter flexwrap">
        <div class="filterbutton clickable flexwrap centercenter mediumShadow textShadow" @click="selectLevel(-1)"
             :class="{'filterbuttonselected' : difficultySelected==-1}" :style="{backgroundColor: '#000000F0'}">
          Tous
        </div>
        <!--<div class="filterbutton" @click="selectLevel(0)"
             :class="{'filterbuttonselected' : difficultySelected==0}"
             :style="{backgroundColor: this.colorLevel[0]}">A1
        </div>-->
        <div class="filterbutton clickable flexwrap centercenter mediumShadow textShadow" @click="selectLevel(1)"
             :class="{'filterbuttonselected' : difficultySelected==1}"
             :style="{backgroundColor: this.colorLevel[1]}">A2
        </div>
        <div class="filterbutton clickable flexwrap centercenter mediumShadow textShadow" @click="selectLevel(2)"
             :class="{'filterbuttonselected' : difficultySelected==2}"
             :style="{backgroundColor: this.colorLevel[2]}">B1
        </div>
        <div class="filterbutton clickable flexwrap centercenter mediumShadow textShadow" @click="selectLevel(3)"
             :class="{'filterbuttonselected' : difficultySelected==3}"
             :style="{backgroundColor: this.colorLevel[3]}">B2
        </div>
        <div class="filterbutton clickable flexwrap centercenter mediumShadow textShadow" @click="selectLevel(4)"
             :class="{'filterbuttonselected' : difficultySelected==4}"
             :style="{backgroundColor: this.colorLevel[4]}">C1
        </div>
        </div>
    </div>

    <div class="rtlcontainer" id="scroller" @scroll="isScrolling" tabindex="0">
      <div style="font-weight: bold; text-align: center; opacity: 0.8">Tout le catalogue Netflix actuellement disponible.</div>
      <div class="posterList" v-if="dataLoaded.ongoing && difficultySelected==-1">
        <div v-for="(element, index) of profile.datas.user_seasons.slice(0,3)"
             :key="index + 1000*difficultySelected + kidsFilter"
             :id="'showPoster_'+index">
          <transition name="fade" mode="out-in" appear>
            <div
                @click="selected(element.season_id)"
                class="poster SmallRoundAngles bigShadow"
                :style="{ backgroundImage: getBackground(showsData[seasonsData[element.season_id].show_id]), borderColor:'#FF8746FF'}" style="overflow: hidden;">
              <div class="new" :style="styleObject(showsData[seasonsData[element.season_id].show_id])">
                saison {{seasonsData[element.season_id].num}}
              </div>
            </div>
          </transition>
        </div>
      </div>

      <div class="posterList">
        <div v-for="(element, index) of filteredIndex"
             v-if="index < scrolledShows"
            :key="index + 1000*difficultySelected + kidsFilter"
          :id="'showPoster_'+index">
          <transition name="fade" mode="out-in" appear>
            <div
                @click="selected(element.id)"
                class="poster SmallRoundAngles bigShadow"
                :class="{'posterselected selected' : seasonsData[element.id].show_id == selectedShow.id}"
                :style="{ backgroundImage: getBackground(showsData[seasonsData[element.id].show_id]), borderColor:seasonsData[element.id].questions?'#FF8746FF':''}" style="overflow: hidden;">
                <div class="difficulty" :style="{backgroundColor: getBG(showsData[seasonsData[element.id].show_id])}">
                </div>
                <div class="new" :style="styleObject(showsData[seasonsData[element.id].show_id])" v-if="getNew(showsData[seasonsData[element.id].show_id])">
                  New
                </div>

                <div class="questions" :style="styleObject(showsData[seasonsData[element.id].show_id])" v-if="seasonsData[element.id].questions">
                  <i class="fas fa-tasks"></i>
                </div>

            </div>

          </transition>

        </div>
        <loading-logo v-if="dataLoaded.topShow&&!dataLoaded.basicShow"></loading-logo>
      </div>
      <div style="width: 75%; height: 75%; justify-self: center" v-if="!dataLoaded.topShow">
        <loading-logo></loading-logo>
      </div>


    </div>


  </div>

</template>

<script>
import {baseShowsNumber} from "../variables.js";
import {mapActions, mapGetters} from 'vuex';
import axios from "axios";
import {API_URL} from "@/App";
import LoadingLogo from "@/components/loadingLogo";

export default {
  name: "showsList",
  components: {
    LoadingLogo,
    Search: () => import(/* webpackPrefetch: true */ '@/components/search.vue'),
  },

  created() {

  },

  computed: {
    ...mapGetters('global', [
        'isMobile',
      'appStep',
      'profile',
      'kidsFilter',
      'showsData',
      'seasonsData',
      'seasonsIndex',
      'dataLoaded',
      'authenticated'
    ]),
    ...mapGetters('show', [
      'currentShow'
    ]),

    filteredIndex: {
      get: function () {
        if (this.difficultySelected !== -1) {
          if(!this.kidsFilter) {
            return this.seasonsIndex.filter((element, index) =>
                this.showsData[this.seasonsData[element.id].show_id].difficulty_level === this.difficultySelected
            )
          }
          else {
            return this.seasonsIndex.filter((element, index) =>
                this.showsData[this.seasonsData[element.id].show_id].difficulty_level === this.difficultySelected
            ).filter(element =>
                this.showsData[this.seasonsData[element.id].show_id].maturityLevel <50)
          }
        }

        if(!this.kidsFilter) {
          return this.seasonsIndex
        }
        else {
          return this.seasonsIndex.filter(element =>
              this.showsData[this.seasonsData[element.id].show_id].maturityLevel <50)
        }
      },
    },

    ongoingSeasons: function(){
      // On renvoie un tableau contenant les 4 derniers shows en cours
      let tempArray = []
          this.profile.datas.user_seasons.slice().forEach((element) => {
            tempArray.push({
              id: element.season_id,
              season: element.season_num
            })
      })


      return tempArray.slice(0,4);
    }
  },
  methods: {
    ...mapActions('global', [
      'set_navOpened',
    ]),
    ...mapActions('show', [
      'set_currentShow',
    ]),



    styleObject: function (show) {
      return {
        '--color': show.color,
      }
    },
    filter: function () {

      /*
      if(!this.dataLoaded.topShow) {
        return this.apiData
      }

      else {
        let temp = new Map();

        // Si le mode enfant est activé
        if (this.kidsFilter) {
          // Si aucun niveau n'est activé
          if (this.difficultySelected !== -1) {
            for (let [key, value] of this.apiData) {
              if (value.difficulty_level == this.difficultySelected && value.maturityLevel < 50) {
                temp.set(key, value)
              }
              //temp = temp.filter(show => show.difficulty_level == this.difficultySelected);
            }
          } else {
            for (let [key, value] of this.apiData) {
              if (value.maturityLevel < 50) {
                temp.set(key, value)
              }
            }
          }
        }

        //Si le mode enfant n'est pas activé
        else {
          if (this.difficultySelected !== -1) {
            for (let [key, value] of this.apiData) {
              if (value.difficulty_level == this.difficultySelected) {
                temp.set(key, value)
              }
              //temp = temp.filter(show => show.difficulty_level == this.difficultySelected);
            }
          } else {
            for (let [key, value] of this.apiData) {
              temp.set(key, value)
            }
          }
        }
        return temp;
      }
      */

      if(!this.dataLoaded.topShow) {
        return this.seasonsIndex
      }

      if (this.difficultySelected !== -1) {
        return this.seasonsIndex.filter((element,) =>
          this.showsData[this.seasonsData[element.id].show_id].difficulty_level === this.difficultySelected
        )
      }

      return this.seasonsIndex
    },

    isScrolling: function () {
      let scrollTop = document.getElementById('scroller').scrollTop;
      let clientHeight = document.getElementById('scroller').clientHeight;
      let scrollHeight = document.getElementById('scroller').scrollHeight;
      let somme = scrollTop + clientHeight+15;
      if (somme >= scrollHeight) {
        this.scrolledShows += 20;
      }
    },
    getBackground: function (show) {
      if (show.poster_path !== null) {
        return 'url(https://learnandwatch.s3.eu-west-3.amazonaws.com/small/' + show.poster_path + '), url(' + require('../assets/placeholder.png') + ')';
      } else {
        return ''
      }
    },
    kidsShowsFilter: function (list) {
      //return list.filter(show => show.maturityLevel < 50);
    },
    selectLevel: function (level) {
      this.scrolledShows = baseShowsNumber;
      this.difficultySelected = level;

      //Pour selectionner le premier show après un filtrage
      if(!this.isMobile){
        this.ongoingFiltering = true
        if (this.currentTimeout != null){
          window.clearTimeout(this.currentTimeout)
        }
        this.currentTimeout = window.setTimeout(() =>
            {
              this.ongoingFiltering = false
              this.currentTimeout= null
            }
            , 600);
      }


      document.getElementById("scroller").scrollTo({top: 0, behavior: 'smooth'});

    },
    selected: function (key) {
      this.selectedShow = this.showsData[this.seasonsData[key].show_id]
      this.$emit('selected', key);
    },
    showDifficulty: function (show) {

      let difficulty = show.difficulty_level;
      if (difficulty == 0) {
        return 'A1'
      } else if (difficulty == 1) {
        return 'A2'
      } else if (difficulty == 2) {
        return 'B1'
      } else if (difficulty == 3) {
        return 'B2'
      } else if (difficulty == 4) {
        return 'C1'
      } else {
        return 'C2'
      }
    },
    getBG: function (show) {
      let difficulty = show.difficulty_level;
      if (difficulty > -1 && difficulty < 5) {
        return this.colorLevel[difficulty]
      } else {
        return "#000000"
      }
    },
    getNew: function (show) {
      let dateShow = Date.parse(show.date_added)
      var d = new Date();
      d.setDate(d.getDate() - 45);
      return dateShow > d
    },

  },
  watch: {
    'kidsFilter': 'filter',
    'dataLoaded.topShow': 'filter',
    'dataLoaded.basicShow': 'filter',
    /*postersNumber: function () {
      this.filterDifficulty();
      for (let i = 0; i < this.seasonsIndex.length; i++) {
        if (this.posters[i].title) {
          this.apiData[i].title = "";
        }
      }
    },*/
    ongoingFiltering: function (){
      if(this.ongoingFiltering==false){
        //this.selected(0,Array.from(this.filteredShows)[0][1].id)
      }
    }

  },
  data: function () {
    return {
      postersNum: this.postersNumber,
      difficultySelected: -1,
      colorLevel: {
        0: "#56cdac",
        1: "#439f40",
        2: "#f49631",
        3: "#EB3B3B",
        4: "#40407F"
      },
      scrolledShows: baseShowsNumber,
      ongoingFiltering: false,
      currentTimeout: null,
      selectedShow: {}
    }
  }
}
</script>

<style scoped>
h2 {
  margin: 0;
}

h3 {
  margin: 0.25vw;
  font-weight: normal;
  color: #ddd
}

.global {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: auto;
  height: 100%;
  max-height: 100%;
}

.rtlcontainer {
  width: auto;
  flex-grow: 1;
  max-height: 100%;
  /*direction: rtl;*/
  overflow: auto;
  scrollbar-color: #f91e48 #bbbbbb !important;
  scrollbar-width: thin !important;
  /*border-top: 0.2vw #00000030 solid;
  border-bottom: 0.2vw #00000030 solid;*/
  flex-wrap: wrap;
  justify-content: center;
  outline: none;
  margin-top: 0.5vw;
}

.posterList {
  display: grid;
  grid-template-columns: repeat(3, 9.25vw);
  grid-auto-rows: 11.75vw;
  /*padding: 0.7vw 0 0 0.7vw;*/
  direction: ltr;
  justify-self: center;
  justify-items: center;
  align-items: center;
  padding-bottom: 0.5vw;
}

.poster {
  position: relative;
  height: 10.7vw;
  width: 7.7vw;
  min-height: 10.5vw;
  min-width: 7.5vw;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  cursor: pointer;
  justify-self: center;
  align-self: center;

  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  /*align-content: flex-start;*/
  overflow: visible;

}

.poster .title {
  position: absolute;
  bottom: 10%;
  left: 0%;
  width: 8vw;
  font-size: 1vw;
  font-weight: bolder;
  align-self: center;
  text-align: center;
}

.poster:hover {
  height: 10.9vw;
  width: 7.9vw;
}

.posterselected {
  height: 10.9vw;
  width: 7.9vw;
  border: 0.14vw solid #52BBF9;
  /*border-radius: 1vw;*/
  box-sizing: border-box;
}

.posterselected > * {
  margin-right: 0.02vw;
}

.difficulty {
  position: absolute;
  margin-bottom: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  width: 20%;
  height: 4%;
  border-radius: 0 0.8vw 0 0.8vw;
  color: white;
}

.new {
  /*position: absolute;*/
  margin-top: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
  align-self: flex-end;
  width: fit-content;
  padding: 0 0.5vw 0 0.5vw;
  height: fit-content;
  background-color: #000000d5;
  color: #eeeeee;
  border-radius: 0.8vw 0 0 0;
  box-shadow: 0 0 0.4vw 0.15vw #068AF6F5;
  font-size: 85%;
  font-weight: bold;
}

.questions {
  /*position: absolute;*/
  margin-top: auto;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
  align-self: flex-end;
  width: fit-content;
  padding: 0.25vw 0.5vw 0.25vw 0.5vw;
  height: fit-content;
  background-color: #000000d5;
  box-shadow: 0 0 0.4vw 0.15vw #ff8746F5;
  color: #eeeeee;
  border-radius: 0.8vw 0 0.8vw 0;
  font-size: 85%;
  font-weight: bold;
  margin-right: -2px;
}
.choosing {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  position: relative;
  justify-content: space-evenly;
  justify-items: center;
}

.search {
  padding: 0;
  max-width: 50%;
  min-width: 14vw;
}

.filter {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: center;
  color: #dddddd;
}

.filterbuttonselected {
  border: 0.08vw solid #52bbf9;
}

.slide-fade-enter-active {
  transition: all .3s;
  -webkit-transition: all .3s;
  -ms-transition: all .3s;
}

.slide-fade-enter /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(-1.5vw);
}

.fade3-item {
  transition: all .5s;
  -webkit-transition: all .5s;
  -ms-transition: all .5s;

}

.fade3-leave-active {
  position: absolute;
  transition: opacity 0s;
}

.fade3-enter /* .fade-leave-active below version 2.1.8 */
{
  /*transform: translateY(-1.5vw);*/
  opacity: 0;
}



@media screen and (max-device-width: 767px) {
  .global {
    flex-grow: 1;
    display: grid;
    grid-template-rows: auto 1fr;
  }
  .posterList {
    grid-template-columns: repeat(3, 30vw);
    grid-auto-rows: 42vw;
    padding: 2vw;
    height: auto;
  }

  .poster {
    height: 39vw;
    width: 27vw;
    min-height: 39vw;
    min-width: 27vw;
  }

  .posterselected {
    height: 40vw;
    width: 28vw;
    border-width: 0.7vw;
    border-radius: 4vw;
  }

  .difficulty {
    width: 23%;
    height: 5%;
    border-radius: 0 0 0 3.2vw;
  }

  .new {
    padding: 0 2vw 0 2vw;
    border-radius: 3.2vw 0 0 0;
    box-shadow: 0 0 1.5vw 0.5vw #068AF6F5;
  }

  .search {
    padding: 0 2vw 2vw 2vw;
    width: 100%;
  }

  .filter {
    width: 100%;
    align-items: center;
  }

  .rtlcontainer {
    margin-top: 2.8vw;
    max-height: calc(100% - 2.8vw);
  }

  .filterbuttonselected {
    border: 0.5vw solid #52bbf9;
  }

  .questions {
    padding: 1vw 2vw 1vw 2vw;
    height: fit-content;
    border-radius: 3vw 0 0 0;
    font-size: 85%;
    font-weight: bold;
    box-shadow: 0 0 1.5vw 0.5vw #ff8746F5;
  }
}

</style>
